/**
 * useAbility Hook
 * Access the current user's ability instance
 */

import { useContext } from 'react';
import { AbilityContext } from '../AbilityContext';

export const useAbility = () => {
  return useContext(AbilityContext);
};
